import type { IconData } from '@stacksjs/iconify-core'

export const interfaceEssentialTextFormat1: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.48 25.91H32v4.57h-1.52Zm0-24.39H32V6.1h-1.52Zm-4.57 28.96h4.57V32h-4.57Zm0-24.38v1.52h1.52v16.76h-1.52v1.53h4.57v-1.53h-1.53V7.62h1.53V6.1zm0-6.1h4.57v1.52h-4.57Z\"/><path fill=\"currentColor\" d=\"M25.91 25.91h-1.53v1.52H7.62v-1.52H6.1v4.57h1.52v-1.53h16.76v1.53h1.53zM21.33 9.14h1.53v3.05h-1.53Z\"/><path fill=\"currentColor\" d=\"M10.67 7.62v1.52h4.57v13.72h-3.05v1.52h7.62v-1.52h-3.05V9.14h4.57V7.62zM9.14 9.14h1.53v3.05H9.14ZM6.1 6.1h1.52V4.57h16.76V6.1h1.53V1.52h-1.53v1.53H7.62V1.52H6.1zM1.52 30.48H6.1V32H1.52Zm4.58-4.57v-1.53H4.57V7.62H6.1V6.1H1.52v1.52h1.53v16.76H1.52v1.53zM1.52 0H6.1v1.52H1.52ZM0 25.91h1.52v4.57H0ZM0 1.52h1.52V6.1H0Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default interfaceEssentialTextFormat1
